var bookshelf = require("../index-extended");
require("./Meeting");
require("./MeetingGuest");
// require("./BuildingLot");

module.exports = bookshelf.model("MeetingGuest", {
  entityName: "MeetingGuest",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "meeting_guest",
  meeting() {
    return this.belongsTo("Meeting");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["meeting"];
    return attrs;
  },
});
